import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      autoComplete="off"
      className={cn(
        'h-10 px-3 typo-secondary text-primary-text',
        'border border-other-stroke rounded',
        'focus:border-primary focus:outline-none ',
        'hover:border-other-stroke-hover',
        'focus-visible:border-primary focus-visible:outline-button-focus focus-visible:outline-offset-1',
        'disabled:text-secondary-text',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
